var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRescheduleOrdersIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.75V10.5",
    stroke: "#ECB062",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2476 12.375L10 10.5",
    stroke: "#ECB062",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.61328 8.29102H2.48828V5.16602",
    stroke: "#ECB062",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13993 15.3614C6.10142 16.3229 7.32642 16.9776 8.66004 17.2429C9.99366 17.5082 11.376 17.372 12.6322 16.8517C13.8885 16.3313 14.9622 15.4501 15.7176 14.3196C16.4731 13.189 16.8763 11.8598 16.8763 10.5C16.8763 9.14026 16.4731 7.81105 15.7176 6.68046C14.9622 5.54987 13.8885 4.66868 12.6322 4.14833C11.376 3.62798 9.99366 3.49183 8.66004 3.7571C7.32642 4.02238 6.10142 4.67716 5.13993 5.63864L2.48828 8.29029",
    stroke: "#ECB062",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRescheduleOrdersIcon);
export default __webpack_public_path__ + "static/media/reschedule-orders-icon.4fb8568dac021258c1df84a3ec7945ca9e868fe8ee68f12091e4f644b2ce7896.svg";
export { ForwardRef as ReactComponent };